import { render, staticRenderFns } from "./TermsContract-05-2022.vue?vue&type=template&id=6cb2f2d9&scoped=true"
import script from "./TermsContract-05-2022.vue?vue&type=script&lang=js"
export * from "./TermsContract-05-2022.vue?vue&type=script&lang=js"
import style0 from "./TermsContract-05-2022.vue?vue&type=style&index=0&id=6cb2f2d9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cb2f2d9",
  null
  
)

export default component.exports